module.exports = __webpack_public_path__ + "act-bg.png?deeae250d1fe4732e59828796088d457";


//////////////////
// WEBPACK FOOTER
// ./src/assets/act-bg.png
// module id = 128
// module chunks = 0